import LegalDocument from "./LegalDocument";
import { pub } from "@/lib/pubThemeClasses";

export default function Privacy() {
  return (
    <LegalDocument eyebrow="Yasal" title="Gizlilik Politikası">
      <p className={`font-sans text-sm leading-relaxed ${pub.muted}`}>
        Bu sayfa yer tutucudur. Kişisel verilerinizin hangi amaçlarla işlendiği, saklanma süreleri ve haklarınız hakkında
        bilgi yakında güncellenecek metinle yayınlanacaktır.
      </p>
      <p className={`font-sans text-sm leading-relaxed mt-4 ${pub.muted}`}>
        Sorularınız için iletişim sayfamızdan bize yazabilirsiniz.
      </p>
    </LegalDocument>
  );
}
